import { render, staticRenderFns } from "./ElementLandlordStoryComp.vue?vue&type=template&id=c8c2e0a6&"
import script from "./ElementLandlordStoryComp.vue?vue&type=script&lang=js&"
export * from "./ElementLandlordStoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports